var DocumentMetaDict = {

    documentMetaFields: {
        creationTime: "Creation time",
        languageCode: "Language code",
        serviceStartTime: "Service start time",
        serviceStopTime: "Service stop time",
        sourcePatientId: "Source patient id",
        sourcePatientInfo: "Source patient info",
        size: "Size",
        hash: "Hash",
        uri: "URI",
        authorPerson: "Author person",
        authorInstitution: "Author institution",
        authorRole: "Author role",
        authorSpecialty: "Author speciality",
        classCode: "Class code",
        confidentialityCode: "Confidentiality code",
        formatCode: "Format code",
        healthcareFacilityTypeCode: "Healthcare facility type code",
        practiceSettingCode: "Practice setting code",
        typeCode: "Type code",
        patientId: "Patient id",
        uniqueId: "Unique id",
        ExtrinsicObjectId: "Extrinsic object id",
        objectType: "Object type",
        mimeType: "Mime type",
        availabilityStatus: "Availability status",
        title: "Title",
        comments: "Comments",
        entryUUID: "Entry UUID",
        eventCode: "Event code",
        intendedRecipient: "Intended recipient",
        legalAuthenticator: "Legal authenticator",
        parentDocumentId: "Parent document id"
    },

    requiredDocumentMetaFields: [
        {field: "creationTime", required: ["value"]},
        {field: "classCode", required: ["nodeRepresentation", "nameLocalizedString"]},
        {field: "mimeType", required: ["value"]}
    ],

    classCodesWithDisplayName: [
        "History of Immunization;11369-6",
        "Anesthesia Records;11485-0",
        "Chemotherapy Records;11486-8",
        "Consultation note;11488-4",
        "Subsequent evaluation note;11506-3",
        "Nursery Records;11543-6",
        "Labor And Delivery Records;15508-5",
        "Radiology Studies;18726-0",
        "Transfer summarization note;18761-7",
        "Discharge summarization note;18842-5",
        "Laboratory Studies;26436-6",
        "Cardiology Studies;26441-6",
        "Obstetrical Studies;26442-4",
        "Gastroenterology Endoscopy Studies;27895-2",
        "Pulmonary Studies;27896-0",
        "Neuromuscular Electrophysiology Studies;27897-8",
        "Pathology Studies;27898-6",
        "Procedure note;28570-0",
        "Ophthalmology Studies;28619-5",
        "Miscellaneous Studies;28634-4",
        "Dialysis Records;29749-9",
        "Neonatal Intensive Care Records;29750-7",
        "Critical Care Records;29751-5",
        "Perioperative Records;29752-3",
        "Evaluation and management note;34109-9",
        "History and physical note;34117-2",
        "Interventional procedure note;34121-4",
        "Pathology procedure note;34122-2",
        "Summarization of episode note;34133-9",
        "Transfer of care referral note;34140-4",
        "Telephone encounter note;34748-4",
        "Pre-operative evaluation and management note;34775-7",
        "Admission history and physical note;47039-3",
        "Counseling note;47042-7",
        "Study report;47045-0",
        "Summary of death;47046-8",
        "Communication;47049-2",
        "Privacy Policy;57017-6",
        "Privacy Policy Acknowledgment;57016-8",
        "Medication Summary;56445-0",
        "Personal health monitoring report;53576-5"
    ],

    confidentialityCodesWithDisplayName: [
        "Business;B",
        "Clinician;D",
        "Individual;I",
        "Low;L",
        "Normal;N",
        "Restricted;R",
        "Very Restricted;V",
        "Substance Abuse Related;ETH",
        "HIV related;HIV",
        "Psychiatry related;PSY",
        "Sexual and Domestic Violence related;SDV",
        "Celebrity;C",
        "Sensitive;S",
        "Taboo;T"
    ],

    formatCodesWithDisplayName: [
        "HL7 CCD Document;urn:ihe:pcc:xphr:2007",
        "IHE Antepartum Summary;urn:ihe:pcc:aps:2007",
        "PDF embedded in CDA per XDS-SD profile;urn:ihe:iti:xds-sd:pdf:2008",
        "Text embedded in CDA per XDS-SD profile;urn:ihe:iti:xds-sd:text:2008",
        "XDS Medical Summaries;urn:ihe:pcc:xds-ms:2007",
        "Personal Health Records;urn:ihe:pcc:xphr:2007",
        "Emergency Department Referral (EDR);urn:ihe:pcc:edr:2007",
        "Emergency Department Encounter Summary (EDES);urn:ihe:pcc:edes:2007",
        "Antepartum Record (APR) - History and Physical;urn:ihe:pcc:apr:handp:2008",
        "Antepartum Record (APR) - Laboratory;urn:ihe:pcc:apr:lab:2008",
        "Antepartum Record (APR) - Education;urn:ihe:pcc:apr:edu:2008",
        "Immunization Registry Content (IRC);urn:ihe:pcc:irc:2008",
        "Cancer Registry Content (CRC);urn:ihe:pcc:crc:2008",
        "Care Management (CM);urn:ihe:pcc:cm:2008",
        "Basic Patient Privacy Consents;urn:ihe:iti:bppc:2007",
        "Basic Patient Privacy Consents with Scanned Document;urn:ihe:iti:bppc-sd:2007",
        "CDA Laboratory Report;urn:ihe:lab:xd-lab:2008",
        "Access Consent Policy document formatted as XACML;urn:nhin:names:acp:XACML"
    ],

    healthcareFacilityTypeCodesWithDisplayName: [
        "Hospital-children's;82242000",
        "Hospital-community;225732001",
        "Hospital-government;79993009",
        "Hospital-long term care;32074000",
        "Hospital-military field;4322002",
        "Hospital-prison;224687002",
        "Hospital-psychiatric;62480006",
        "Hospital-rehabilitation;80522000",
        "Hospital-trauma center;36125001",
        "Hospital-Veterans' Administration;48311003",
        "Hospice facility;284546000",
        "Nursing home;42665001",
        "Skilled nursing facility;45618002",
        "Dialysis unit--hospital;418518002",
        "Emergency department--hospital;73770003",
        "Hospital ambulatory surgery facility;69362002",
        "Hospital birthing center;52668009",
        "Hospital outpatient allergy clinic;360957003",
        "Hospital outpatient dental clinic;10206005",
        "Hospital outpatient dermatology clinic;37550003",
        "Hospital outpatient endocrinology clinic;73644007",
        "Hospital outpatient family medicine clinic;31628002",
        "Hospital outpatient gastroenterology clinic;58482006",
        "Hospital outpatient general surgery clinic;90484001",
        "Hospital outpatient geriatric health center;1814000",
        "Hospital outpatient gynecology clinic;22549003",
        "Hospital outpatient hematology clinic;56293002",
        "Hospital outpatient immunology clinic;360966004",
        "Hospital outpatient infectious disease clinic;2849009",
        "Hospital outpatient mental health center;14866005",
        "Hospital outpatient neurology clinic;38238005",
        "Hospital outpatient obstetrical clinic;56189001",
        "Hospital outpatient oncology clinic;89972002",
        "Hospital outpatient ophthalmology clinic;78088001",
        "Hospital outpatient orthopedics clinic;78001009",
        "Hospital outpatient otorhinolaryngology clinic;23392004",
        "Hospital outpatient pain clinic;36293008",
        "Hospital outpatient pediatric clinic;3729002",
        "Hospital outpatient peripheral vascular clinic;5584006",
        "Hospital outpatient rehabilitation clinic;37546005",
        "Hospital outpatient respiratory disease clinic;57159002",
        "Hospital outpatient rheumatology clinic;331006",
        "Hospital outpatient urology clinic;50569004",
        "Hospital radiology facility;79491001",
        "Hospital-based outpatient clinic or department;33022008",
        "Fee-for-service private physicians' group office;19602009",
        "Private physicians' group office;39350007",
        "Solo practice private office;83891005",
        "Independent ambulatory care provider site;394759007",
        "Ambulatory surgery center;405607001",
        "Care of the elderly day hospital;309900005",
        "Elderly assessment clinic;275576008",
        "Free-standing ambulatory surgery facility;10531005",
        "Free-standing birthing center;91154008",
        "Free-standing geriatric health center;41844007",
        "Free-standing laboratory facility;45899008",
        "Free-standing mental health center;51563005",
        "Free-standing radiology facility;1773006",
        "Health maintenance organization;72311000",
        "Local community health center;6827000",
        "Psychogeriatric day hospital;309898008",
        "Residential school infirmary;39913001",
        "Rural health center;77931003",
        "Sexually transmitted disease health center;25681007",
        "Substance abuse treatment center;20078004",
        "Vaccination clinic;46224007",
        "Walk-in clinic;81234003",
        "Ambulatory care site;35971002",
        "Ambulance-based care;11424001",
        "Contained casualty setting;409519008",
        "Helicopter-based care;901005",
        "Hospital ship;2081004",
        "Traveler's aid clinic;59374000",
        "Adult day care center;413456002",
        "Child day care center;413817003",
        "Private residential home;310205006",
        "Residential institution;419955002",
        "Sports facility;272501009",
        "Health encounter site;394777002",
    ],

    practiceSettingCodesWithDisplayName: [
        "Adult mental illness;408467006",
        "Anesthetics;394577000",
        "Audiological medicine;394578005",
        "Blood banking and transfusion medicine;421661004",
        "Burns care;408462000",
        "Cardiology;394579002",
        "Clinical cytogenetics and molecular genetics;394804000",
        "Clinical genetics;394580004",
        "Clinical hematology;394803006",
        "Clinical immunology;408480009",
        "Clinical microbiology;408454008",
        "Clinical neuro-physiology;394809005",
        "Clinical oncology;394592004",
        "Clinical pharmacology;394600006",
        "Clinical physiology;394601005",
        "Community medicine;394581000",
        "Critical care medicine;408478003",
        "Dental medicine specialties;394812008",
        "Dental-General dental practice;408444009",
        "Dermatology;394582007",
        "Diabetic medicine;408475000",
        "Dive medicine;410005002",
        "Endocrinology;394583002",
        "Family practice;419772000",
        "Gastroenterology;394584008",
        "General medical practice;408443003",
        "General medicine;394802001",
        "General pathology;394915009",
        "General practice;394814009",
        "Genito-urinary medicine;394808002",
        "Geriatric medicine;394811001",
        "Gynecological oncology;408446006",
        "Gynecology;394586005",
        "Hematopathology;394916005",
        "Hepatology;408472002",
        "Histopathology;394597005",
        "Immunopathology;394598000",
        "Infectious diseases;394807007",
        "Internal medicine;419192003",
        "Learning disability;408468001",
        "Medical oncology;394593009",
        "Medical ophthalmology;394813003",
        "Military medicine;410001006",
        "Nephrology;394589003",
        "Neurology;394591006",
        "Neuropathology;394599008",
        "Nuclear medicine;394649004",
        "Obstetrics;408470005",
        "Obstetrics and gynecology;394585009",
        "Occupational medicine;394821009",
        "Ophthalmic surgery;422191005",
        "Ophthalmology;394594003",
        "Osteopathic manipulative medicine;416304004",
        "Otolaryngology;418960008",
        "Pain management;394882004",
        "Palliative medicine;394806003",
        "Pediatric (Child and adolescent) psychiatry;394588006",
        "Pediatric cardiology;408459003",
        "Pediatric dentistry;394607009",
        "Pediatric endocrinology;419610006",
        "Pediatric gastroenterology;418058008",
        "Pediatric genetics;420208008",
        "Pediatric hematology;418652005",
        "Pediatric immunology;418535003",
        "Pediatric infectious diseases;418862001",
        "Pediatric nephrology;419365004",
        "Pediatric oncology;418002000",
        "Pediatric ophthalmology;419983000",
        "Pediatric pulmonology;419170002",
        "Pediatric rheumatology;419472004",
        "Pediatric surgery;394539006",
        "Pediatric surgery-bone marrow transplantation;420112009",
        "Preventive medicine;409968004",
        "Psychiatry;394587001",
        "Psychotherapy;394913002",
        "Public health medicine;408440000",
        "Pulmonary medicine;418112009",
        "Radiation oncology;419815003",
        "Radiology;394914008",
        "Radiology-Interventional radiology;408455009",
        "Rehabilitation;394602003",
        "Respite care;408447002",
        "Rheumatology;394810000",
        "Sleep studies;408450004",
        "Surgery-Bone and marrow transplantation;408476004",
        "Surgery-Breast surgery;408469009",
        "Surgery-Cardiac surgery;408466002",
        "Surgery-Cardiothoracic transplantation;408471009",
        "Surgery-Colorectal surgery;408464004",
        "Surgery-Dental-Endodontics;408441001",
        "Surgery-Dental-Oral and maxillofacial surgery;408465003",
        "Surgery-Dental-Oral surgery;394605001",
        "Surgery-Dental-Orthodontics;394608004",
        "Surgery-Dental-Periodontal surgery;408461007",
        "Surgery-Dental-Prosthetic dentistry (Prosthodontics);408460008",
        "Surgery-Dental-surgical-Prosthodontics;408460008",
        "Surgery-Dentistry-Restorative dentistry;394606000",
        "Surgery-Dentistry--surgical;408449004",
        "Surgery-Dentistry-surgical-Orthodontics;394608004",
        "Surgery-Dermatologic surgery;418018006",
        "Surgery-Ear, nose and throat surgery;394604002",
        "Surgery-general;394609007",
        "Surgery-Hepatobiliary and pancreatic surgery;408474001",
        "Surgery-Neurosurgery;394610002",
        "Surgery-Plastic surgery;394611003",
        "Surgery-Transplantation surgery;408477008",
        "Surgery-Trauma and orthopedics;394801008",
        "Surgery-Vascular;408463005",
        "Surgical oncology;419321007",
        "Surgical-Accident & emergency;394576009",
        "Thoracic medicine;394590007",
        "Toxicology;409967009",
        "Tropical medicine;408448007",
        "Urological oncology;419043006",
        "Urology;394612005",
        "Medical specialty;394733009",
        "Surgical specialty;394732004"
    ],

    documentMimeTypes: [
        "application/pdf",
        "image/gif",
        "image/jpeg",
        "image/png",
        "text/plain",
        "text/xml"
    ]

};


module.exports = DocumentMetaDict;


//////////////////
// WEBPACK FOOTER
// ./app/data/document-meta-dict.js
// module id = 194
// module chunks = 0